<template>
  <div>
    <v-chip v-for="(keyword, i) in wordArray" :key="i" x-small pill color="primary" class="mr-1">
     #{{ keyword }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'KeywordsRow',
  props: {
    keywords: { type: String },
  },
  computed: {
    wordArray() {
      if (!this.keywords) return []
      if (!this.keywords.trim()) return []
      return this.keywords.split(' ').map((w) => w.toLowerCase().trim())
    },
  },
  methods: {
  },
}
</script>

<style lang="less" scoped></style>
